import React from 'react';
import { Container } from '@mui/material';

export default React.forwardRef((props, ref) => {
  return (
    <Container maxWidth={false} ref={ref} {...props}>
      {props.children}
    </Container>
  );
});
